import { parseURN } from '@/components/maps/shared/catalog/utils/CoordinatesUtils';
import { isInteger, isNumber, isJson } from '@config/utils'
import { Stroke, Style, Circle } from 'ol/style';
import { getVectorContext } from 'ol/render';
import { unByKey } from 'ol/Observable';
import { getCenter } from 'ol/extent';
import { GeoJSON } from "ol/format";
import { easeOut } from 'ol/easing';

let vars = {
    flashListenerKey: null,
};

export default {
    mixins: [
    ],
    props: {

    },
    data() {
        return {
            idPanelFeatures: 'features',
        }
    },
    created() {

    },
    computed: {
        tool(){
            return this.$store.getters[`${this.moduleCode}/getTool`](this.idPanelFeatures);
        },
        selectConfig() {
            return this.tool ? this.tool.select || {} : null;
        },
    },
    methods: {
        getFeatureFromGeoJson(geojson, map) {
            if (isJson(geojson)) {
                let options = {};
                if(map) {
                    const view = map.getView();
                    const viewProjection = view.getProjection();
                    options = {
                        dataProjection: geojson?.crs ? parseURN(geojson?.crs) : viewProjection,
                        featureProjection: viewProjection
                    }
                }
                let format = new GeoJSON();
                return format.readFeature(geojson, options);
            }
            return null;
        },
        animateToFeature(params={}) {
            const {map, layer, feature, geojson, zoom=false, forceCenter=false, duration=(this.selectConfig.duration ?? 1000), callback = null} = params;
            if(!map) return;

            const view = map.getView();
            const viewCenter = view.getCenter();

            let _feature = geojson ? this.getFeatureFromGeoJson(geojson, map) : feature;
            if(!_feature) return;

            let center = viewCenter;
            let zoomLevel = view.getZoom();

            let geom = _feature.getGeometry();
            if(isInteger(zoom)) {
                zoomLevel = zoom;
            }else if(isNumber(zoom)) {
                zoomLevel = view.getZoomForResolution(zoom);
            }else if(zoom === true) {
                let _geom = geom.clone()
                _geom.scale(1.25);
                zoomLevel = view.getZoomForResolution(view.getResolutionForExtent(geom.getExtent()));
                center = getCenter(geom.getExtent());
            }else if(zoom) {
                zoomLevel = view.getMaxZoom();
            }

            // let _forceCenter = forceCenter;
            // let coords = geom.getCoordinates();
            // if(coords[0] > viewCenter[0]){
            //     let resolution = view.getResolutionForZoom(zoomLevel);
            //     coords = [coords[0] + 30*resolution, coords[1]];
            //     _forceCenter = true;
            // }
            view.animate({
                center: center,
                zoom: zoomLevel,
                duration: duration,
            }, function(complete) {
                if (typeof callback === "function") {
                    callback(complete, map, layer, _feature, zoom);
                }
            });
        },
        flashFeature(params={}) {
            const {map, layer, feature, geojson, duration=3000, callback = null} = params;
            if(!map) return;

            let _feature = geojson ? this.getFeatureFromGeoJson(geojson, map) : feature;
            if(!_feature) return;

            const start = Date.now();
            const flashGeom = _feature.getGeometry().clone();
            // Existe um problema com o 'postrender' que inicialmente dispara 2x sem justificação e que faz com que fique sempre um circulo pequeno qd se fecha a modal
            // Enquanto não se percebe a razão, fiz este workarround com o _frameStateTime
            let _frameStateTime = null
            const animate = (event) => {
                const frameState = event.frameState;
                const frameStateTime = frameState.time;
                const elapsed = frameStateTime - start;
                ////////////////////////
                // workarround !!
                if(!_frameStateTime) {
                    _frameStateTime = frameStateTime;
                }
                if(frameStateTime <= _frameStateTime) {
                    if(vars.flashListenerKey) {
                        map.render();
                    }
                    return;
                }
                ////////////////////////

                const vectorContext = getVectorContext(event);
                const elapsedRatio = (elapsed % duration) / duration;

                // radius will be 5 at start and 30 at end.
                const radius = easeOut(elapsedRatio) * 25 + 5;
                const opacity = easeOut(1 - elapsedRatio);

                const style = new Style({
                    image: new Circle({
                        radius: radius,
                        stroke: new Stroke({
                            color: 'rgba(255, 0, 0, ' + opacity + ')',
                            width: 0.25 + opacity,
                        }),
                    }),
                });

                vectorContext.setStyle(style);
                vectorContext.drawGeometry(flashGeom);
                // tell OpenLayers to continue postrender animation
                if(vars.flashListenerKey) {
                    map.render();
                }
            };

            const listenerKey = vars.flashListenerKey;
            const tt = !!listenerKey;
            if(listenerKey) {
                unByKey(listenerKey);
                vars.flashListenerKey = null;
            }
            vars.flashListenerKey = layer ? layer.on('postrender', animate) : null;
            if(vars.flashListenerKey) {
                map.render();
            }
        },
        resetFlashFeature(params={}) {
            const {map, ...rest} = params;

            const listenerKey = vars.flashListenerKey;
            if(listenerKey) {
                unByKey(listenerKey);
                vars.flashListenerKey = null;
                if(map){
                    map.render();
                }
            }
        }
    },
}